import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import Single from './Single';
import './App.css';

function App() {
  return (
    <div className="app">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/single" element={<Single />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
